var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1574 35.0961L20.9614 23.9851L32.1574 12.874C32.4245 12.6089 32.6364 12.2942 32.781 11.9478C32.9256 11.6014 33 11.2301 33 10.8551C33 10.4802 32.9256 10.1089 32.781 9.76253C32.6364 9.41612 32.4245 9.10138 32.1574 8.83625C31.8902 8.57113 31.5731 8.36082 31.224 8.21734C30.875 8.07385 30.5008 8 30.123 8C29.7452 8 29.3711 8.07385 29.0221 8.21734C28.673 8.36082 28.3559 8.57113 28.0887 8.83625L14.844 21.9805C13.7187 23.0973 13.7187 24.9015 14.844 26.0183L28.0887 39.1625C28.3557 39.428 28.6728 39.6386 29.0218 39.7823C29.3709 39.926 29.7451 40 30.123 40C30.501 40 30.8752 39.926 31.2242 39.7823C31.5733 39.6386 31.8904 39.428 32.1574 39.1625C33.2539 38.0457 33.2827 36.213 32.1574 35.0961Z",
    fill: "#0784B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingBackArrow);
export default __webpack_public_path__ + "static/media/landingBackArrow.fc13b4e1edb1d1dad668d42ad207359a.svg";
export { ForwardRef as ReactComponent };